import { Link } from 'react-router-dom';
import { imgUrl } from '../../../Helpers/Constant';
import { IExhibitorPubList } from '../../../Types/RegisterTypes';
import { Container, Row, Col, Card } from 'react-bootstrap';
type IProps = {
  response: IExhibitorPubList[] | undefined;
};
const ExhibitorCard = ({ response }: IProps) => {
  return (
    <>
      <Container className='mt-3'>
        <Row className='g-4'>
          {response?.map((item) => (
            <Col key={item.user_fair_member_id} md={6}>
              <Link
                to={`/product-services/exhibitor/details/${item.user_fair_member_id}`}
                style={{ textDecoration: 'none', color: 'inherit' }}
              >
                <Card className='h-100 border-0 shadow-sm'>
                  <Row>
                    <Col md={6}>
                      <div className='d-flex flex-row align-items-center p-3'>
                        {/* Image Section */}
                        <div className='me-3'>
                          <Card.Img
                            src={
                              item?.user_fair_member_company_logo
                                ? `${imgUrl}/${item?.user_fair_member_company_logo}`
                                : '/blank-image.png'
                            } // Replace with actual image source if available
                            alt={item.user_fair_member_company_logo}
                            style={{
                              width: '100%',
                              minHeight: '150px',
                              objectFit: 'cover',
                              borderRadius: '5px',
                            }}
                          />
                        </div>
                      </div>
                    </Col>
                    <Col md={6}>
                      <div className='d-flex flex-row align-items-center p-3'>
                        <div>
                          <Card.Body className='p-0'>
                            <Card.Title className='fw-bold mb-2'>
                              {item.user_fair_member_company_name}
                            </Card.Title>
                            <div>
                              {item?.fair_stall_list?.map((stall) => (
                                <div key={stall.fair_stall_id} className='mb-2'>
                                  <Card.Text className='fw-bold'>
                                    {stall.fair_stall_hall_name}-{'Hall-'}
                                    {`(${stall.fair_stall_type}- ${stall.stall_no})`}
                                  </Card.Text>
                                </div>
                              ))}
                            </div>
                          </Card.Body>
                        </div>
                      </div>
                    </Col>
                  </Row>
                </Card>
              </Link>
            </Col>
          ))}
        </Row>
      </Container>
      {/* {response?.length ? (
        <>
          <div
            className='grid-container'
            style={{
              display: 'grid',
              gridTemplateColumns: 'repeat(auto-fill, minmax(600px, 1fr))',
              gap: '1rem',
              alignItems: 'start',
            }}
          >
            {response?.map((sEvent) => {
              return (
                <div
                  className='grid-item'
                  key={sEvent.user_fair_member_id}
                  style={{
                    display: 'flex',
                    flexDirection: 'row',
                    background: 'white',
                    height: '100%',
                    gap: '1rem',
                    padding: '1rem',
                    borderRadius: '5px',
                    border: '1px solid #ddd',
                    alignItems: 'center',
                  }}
                >
                  
                  <div
                    style={{
                      flex: '1 1 200px',
                      maxWidth: '200px',
                      borderRadius: '5px',
                      overflow: 'hidden',
                    }}
                  >
                    <img
                      src={
                        sEvent.user_fair_member_company_logo
                          ? `${imgUrl}/${sEvent?.user_fair_member_company_logo}`
                          : '/blank-image.png'
                      }
                      alt={sEvent.user_fair_member_company_logo}
                      style={{
                        width: '100%',
                        height: 'auto',
                        objectFit: 'cover',
                        borderRadius: '5px',
                      }}
                    />
                  </div>

              
                  <div
                    style={{
                      flex: '2 1 auto',
                      display: 'flex',
                      flexDirection: 'column',
                      gap: '0.5rem',
                    }}
                  >
                    <h5 style={{ fontWeight: 'bold' }}>
                      {sEvent.user_fair_member_company_name}
                    </h5>
                    <h5 color='text.secondary'>
                      <FaRegBuilding /> {sEvent.user_fair_member_company_name}
                    </h5>
                    <h5 color='text.secondary'>
                      <MdOutlineCategory />{' '}
                      {sEvent.user_fair_member_company_name}
                    </h5>
                    <h5 color='text.secondary'>
                      <FaMoneyBillWave />{' '}
                      <span style={{ textDecoration: 'line-through' }}>
                        Tk. {sEvent.user_fair_member_company_name}
                      </span>
                    </h5>
                  </div>
                </div>
              );
            })}
          </div>
        </>
      ) : (
        <p className='text-center fs-4 fw-bold'>No event found</p>
      )} */}
    </>
  );
};

export default ExhibitorCard;
